export enum NoteType {
  Structure = 1,
  NOrder = 2,
  BittingList = 3,
  Fsic = 4,
}
